import { createUseStyles } from 'react-jss'

export const emptyStateCards = {
  card: {
    composes: 'card',
    borderRadius: 0,
    flex: '1 1 0',
    height: 300,
    justifyContent: 'center'
  },
  cardText: {
    margin: '50px 25px 30px',
    textAlign: 'center'
  }
}

export const style = {
  ...emptyStateCards,
  question: {
    fontSize: 24,
    marginBottom: 40,
    textAlign: 'center'
  },
  container: {
    composes: 'flex-row',
    width: 900
  },
  cardSeparator: {
    margin: 25,
    alignItems: 'center',
    display: 'flex',
    textTransform: 'uppercase',
    fontSize: 24,
    fontFamily: 'Raleway'
  }
}

export const useStyles = createUseStyles(style)
